import React, { useCallback, useContext, useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useToasts } from "react-toast-notifications";
import { createPlaceCategory } from '../../../service/placeCategoryService';
import { placeCategoryValidatior } from '../../../service/validatorForms';
import DashboardContext from '../../context/dashboardContext';
import './CreatePlaceCategory.css';
import { digitsArToEn, digitsFaToEn } from '@persian-tools/persian-tools';


const CreatePlaceCategory = () => {
    const [name, setName] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [, setForceUpdate] = useState();
    const forceUpdate = useCallback(() => setForceUpdate({}), []);
    const validatorRef = useRef(placeCategoryValidatior());
    const { addToast } = useToasts();
    const history = useHistory();
    const dashContext = useContext(DashboardContext);


    const submitHandler = async (event) => {
        event.preventDefault();
        try {
            if (validatorRef.current.allValid()) {
                const info = {
                    title: name,
                }
                setIsLoading(true);
                const { status } = await createPlaceCategory(info);
                if (status === 201) {
                    addToast("ایجاد دسته بندی جدید با موفقیت انجام شد", {
                        appearance: 'success',
                        autoDismiss: true,
                    })
                    validatorRef.current.hideMessageFor("name");
                    validatorRef.current.hideMessages();
                    dashContext.setPlaceCategoryCount(dashContext.placeCategoryCount + 1);
                    setName("");
                    forceUpdate();
                    setIsLoading(false);
                }
            }
            else {
                validatorRef.current.showMessages();
                forceUpdate();
            }
        } catch (err) {
            if (err.response && err.response.status === 404) {
                addToast("این دسته بندی قبلا ثبت شده است", {
                    appearance: 'error',
                    autoDismiss: true,
                })
            }
            else if (err.response && err.response.status === 422) {
                addToast("اطلاعات را کامل وارد کنید", {
                    appearance: 'warning',
                    autoDismiss: true,
                })
            }
            if (err.response && err.response.status === 401) {
                addToast("عدم دسترسی مجاز", {
                    appearance: 'error',
                    autoDismiss: true,
                })
                history.replace('/login');
            }
            setIsLoading(false);
            setName("");
            validatorRef.current.hideMessageFor("name");
            validatorRef.current.hideMessages();
            forceUpdate();
        }
    }

    return (
        <React.Fragment>
            <div className="create-category-layer px-sm-5 px-md-5">
                <header>
                    <h1>ایجاد دسته بندی مکانی جدید </h1>
                </header>
                <form onSubmit={submitHandler} className="form my-3">
                    <div className="form-row align-items-end ">
                        <div className="form-group mx-1 mb-2">
                            <label htmlFor="inputName">
                                نام دسته بندی مکانی
                            </label>
                            <input
                                type="text"
                                className="form-control"
                                id="inputName"
                                value={name}
                                onChange={(e) => setName(digitsFaToEn(digitsArToEn(e.target.value)))}
                                name="name"
                                placeholder="نام دسته بندی مکانی"
                                onBlur={() => {
                                    if (name !== '') {
                                        validatorRef.current.showMessageFor("name");
                                        forceUpdate()
                                    }
                                }}
                                onKeyPress={(e) => { e.key === 'Enter' && e.preventDefault() }}
                            />
                            {validatorRef.current.message(
                                "name",
                                name,
                                "required"
                            )}
                        </div>
                        <button
                            type="submit"
                            className="btn btn-success mb-2 px-4 ml-2"
                            disabled={isLoading}
                        >
                            <i
                                className={isLoading ? 'spinner-border spinner-border-sm mr-2' : ''}
                                style={{ position: 'relative', bottom: '2px' }}
                            ></i>
                            ثبت
                        </button>
                    </div>
                </form>

            </div>
        </React.Fragment>
    );
}

export default CreatePlaceCategory;